function withoutCountdowns( value: unknown ): unknown
{
  if ( Array.isArray( value ) )
    return value.map( withoutCountdowns );
  if ( !value || typeof value !== "object" )
    return value;
  const out: Record<string, unknown> = {};
  for ( const [ key, inner ] of Object.entries( value as Record<string, unknown> ) )
  {
    if ( key.startsWith( "seconds_until" ) )
      continue;
    out[key] = withoutCountdowns( inner );
  }
  return out;
}

export function eventPayloadKey( payload: unknown ): string
{
  return JSON.stringify( withoutCountdowns( payload ?? null ) );
}

export type EventPayloadListener<T> = ( payload: T | null ) => void;

export class EventPayloadListeners<T>
{
  private listeners = new Set<EventPayloadListener<T>>();

  public add( listener: EventPayloadListener<T> ): () => void
  {
    this.listeners.add( listener );
    return () => { this.listeners.delete( listener ); };
  }

  public notify( payload: T | null ): void
  {
    for ( const listener of [ ...this.listeners ] )
    {
      try { listener( payload ); }
      catch ( e ) { console.warn( "[EventPayloadListeners] listener failed", e ); }
    }
  }
}
